<section class="new-experience-dialog">
  <div class="new-experience-dialog__header">
    <h2 matDialogTitle class="new-experience-dialog__title">
      UpLink has a new look and feel!
    </h2>
    <button
      mat-icon-button
      class="new-experience-dialog__close"
      aria-label="Close new experience dialog"
      (click)="close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="new-experience-dialog__body">
    <div class="new-experience-dialog__preview">
      <img
        class="new-experience-dialog__preview-image"
        [src]="previewImageSrc"
        alt="Preview of the new UpLink experience"
      />
    </div>

    <p class="new-experience-dialog__copy">
      We've redesigned UpLink with a cleaner layout and updated visual style.
      Everything you're used to is still in place, but the experience has been
      streamlined for clarity and ease of use.
    </p>
    <p class="new-experience-dialog__copy">You may need to sign in again.</p>
  </mat-dialog-content>

  <mat-dialog-actions class="new-experience-dialog__actions" align="end">
    <button
      mat-stroked-button
      color="primary"
      class="new-experience-dialog__secondary-action"
      (click)="close()"
    >
      Use old experience
    </button>
    <button
      mat-flat-button
      color="primary"
      class="new-experience-dialog__primary-action"
      (click)="tryNewExperience()"
    >
      Sign in to new experience
    </button>
  </mat-dialog-actions>
</section>
